module.exports = {"menu":{"home":"Inicio","events":"Eventos","myYoop":"Mi Yoop","profile":"Perfil","login":"Iniciar sesión","logout":"Cerrar sesión","signUp":"Regístrate","about":"Acerca de","careers":"Únete a nosotros","contact":"Contáctanos","privacyPolicy":"Política de privacidad","termsOfUse":"Condiciones de Uso","support":"Soporte"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src332225586/src/modules/web/src/js/i18n/spanish/menu.es.i18n.json
// module id = 1341
// module chunks = 0